import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCartActionMutation } from 'src/store/api/cart/catsApiSlice';
import { isAuthSelector } from 'src/store/reducers/auth';
import { cartAddItem, cartRemoveItem, cartReset } from 'src/store/reducers/cart';
import { RootState } from 'src/store/store';
import { CartItemType } from 'src/types/cart/CartItem';
import { storageAddCartItem, storageCartReset, storageRemoveCartItem } from 'src/utils/cart';



const useCartAction = (item?: CartItemType) => {
    const dispatch = useDispatch();
    const isAuth = useSelector(isAuthSelector);
    const [sendCartAction] = useCartActionMutation();

    const qty = useSelector((state: RootState) => {

        if (item) {
            const cartState = state.cart.items || [];
            const itemInCart = cartState.find((itm: CartItemType) => itm.slug === item.slug);
            return itemInCart ? itemInCart.qty : 0;
        }
        return 0
    });


    const cartAddPress = useCallback(async () => {

        if (item) {
            dispatch(cartAddItem({ cartItem: item }));

            storageAddCartItem(item);
            if (isAuth) {
                await sendCartAction({ action: "add", slug: item.slug, qty: 1 });
            }
        }
    }, [item, dispatch, isAuth, sendCartAction]);

    const cartRemovePress = useCallback(async () => {
        if (item) {
            dispatch(cartRemoveItem({ slug: item.slug }));
            storageRemoveCartItem(item.slug);
            if (isAuth) {
                await sendCartAction({ action: "remove", slug: item.slug });
            }
        }
    }, [item, dispatch, isAuth, sendCartAction]);

    const cartResetPress = useCallback(async () => {
        dispatch(cartReset());
        storageCartReset();
        if (isAuth) {
            await sendCartAction({ action: "reset" });
        }
    }, [isAuth, sendCartAction, dispatch]);


    return { qty, cartAddPress, cartRemovePress, cartResetPress }
};

export default useCartAction;